import { BankHoliday, Country, CreateBankHolidayInput } from "../../../API";
import { toAWSDate } from "../../../lib";

type ExistingBankHolidayProps = {
  bankHolidays?: BankHoliday[] | null;
  currentBankHolidayId?: string | null;
  country: Country;
  counties?: (string | null)[];
  date: Date | string;
};

export const checkIfExistingBankHoliday = ({
  bankHolidays,
  currentBankHolidayId,
  country,
  counties,
  date,
}: ExistingBankHolidayProps) => {
  if (!bankHolidays || bankHolidays.length === 0) return false;

  return !!bankHolidays?.find((a) => {
    // If Updating current Bank Holiday ignore
    if (a.id === currentBankHolidayId) return false;

    const currDate = a.date;
    const newDate = toAWSDate(new Date(date));

    const currCountry = a.countryCode;
    const currCounties = a.counties;

    return (
      currDate === newDate &&
      currCountry === country &&
      currCounties?.some((c) => counties && counties.includes(c ?? ""))
    );
  });
};

export type FormFields = CreateBankHolidayInput;

export const mapDefaultValues = (value?: FormFields) => ({
  id: value?.id,
  date: value?.date ?? new Date(),
  countryCode: value?.countryCode ?? Country.GB,
  localName: value?.localName ?? "",
  counties: value?.counties ?? [],
});
